import { Container } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthForm, ModalMessage } from "../../components";
import { registerApi } from "../../api/authApi.js";
import * as Yup from "yup";
import { successMsgDuration } from "../../constants/config";

export default function Register() {
  // Register Form with validation (formik + Yup libraries)

  // form validation schema (with Yup)
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Please enter your first name"),
    lastName: Yup.string().required("Please enter your last name"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter your email"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters long.")
      .required("Please enter a valid password"),
    confirmPassword: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("password"), null], "Passwords must match"), //confirmPassword must match 'password'
  });

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  };

  const formFields = [
    { name: "firstName", label: "First Name", type: "text" },
    { name: "lastName", label: "Last Name", type: "text" },
    { name: "email", label: "Email", type: "email" },
    { name: "password", label: "Password", type: "password" },
    { name: "confirmPassword", label: "Confirm Password", type: "password" },
  ];

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const handleFormSubmission = async (formData) => {
    //API call
    // formData = {email:(String), password:(String), ........}
    const abortController = new AbortController();
    try {
      const res = await registerApi(
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
        },
        abortController.signal
      );
      setSuccessMsg("Account created successfully.");
      // wait before redirecting to login page
      await new Promise((resolve) => setTimeout(resolve, successMsgDuration));
      // redirect to login page
      navigate("/login", { state: { email: res.email }, replace: true }); //pass email to login, reset history
    } catch (error) {
      setErrorMsg(`${error.message}`);
    }
  };

  return (
    <Container>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      {successMsg && (
        <ModalMessage
          autoClose={true}
          type="success"
          message={successMsg}
          setSuccessMsg={setSuccessMsg}
        />
      )}
      <AuthForm
        registration={true}
        validationSchema={validationSchema}
        initialValues={{...initialValues}}
        handleFormSubmission={handleFormSubmission}
        formFields={formFields}
      />
    </Container>
  );
}
